import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { mobile } from '~/techstyle-shared/react-components';

const Divider = styled.div`
  color: ${({ theme }) => theme.colors.mysteryBoxLabel};
  font-size: 14px;
  font-weight: 700;
  padding-bottom: 16px;

  ${mobile`
    padding: 0 16px 32px;
  `}
`;

export default function MysteryBoxSectionDivider({ children }) {
  return <Divider>{children}</Divider>;
}

MysteryBoxSectionDivider.propTypes = {
  children: PropTypes.node.isRequired,
};
